/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my token sent anywhere?`)
};

const es_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se envía mi token a algún lugar?`)
};

const de_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird mein Token irgendwohin gesendet?`)
};

const nl_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt mijn token ergens naartoe verzonden?`)
};

const fr_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon jeton est-il envoyé quelque part ?`)
};

const it_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio token viene inviato da qualche parte?`)
};

const pt_br2_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meu token é enviado para algum lugar?`)
};

const pt_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O meu token é enviado para algum lado?`)
};

const ja_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トークンはどこかに送信されますか？`)
};

const zh_jw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的令牌会被发送到别处吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_faq3_q", locale)
	if (locale === "en") return en_jw_faq3_q(inputs)
	if (locale === "es") return es_jw_faq3_q(inputs)
	if (locale === "de") return de_jw_faq3_q(inputs)
	if (locale === "nl") return nl_jw_faq3_q(inputs)
	if (locale === "fr") return fr_jw_faq3_q(inputs)
	if (locale === "it") return it_jw_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_jw_faq3_q(inputs)
	if (locale === "pt") return pt_jw_faq3_q(inputs)
	if (locale === "ja") return ja_jw_faq3_q(inputs)
	return zh_jw_faq3_q(inputs)
};